<label class="ds-radio-button-wrapper">
    <input
        #input
        type="radio"
        [name]="name()"
        [value]="value()"
        [checked]="checked()"
        [disabled]="disabled()"
        (change)="onInputChange($event)"
        (click)="onInputClick($event)"
        [attr.aria-checked]="checked()"
        [attr.aria-posinset]="position()"
        [attr.aria-setsize]="setSize()"
        [attr.aria-label]="generatedAriaLabel()"
        [attr.aria-labelledby]="ariaLabelledby()"
        [attr.aria-describedby]="ariaDescribedby()"
        class="ds-radio-button-input" />
    <div class="ds-radio-button-lever-wrapper">
        <span class="ds-radio-button-lever"></span>
    </div>
    <div class="ds-radio-button-text-wrapper">
        <span class="ds-radio-button-label-text">
            <ng-content />
        </span>
    </div>
</label>
